import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
} from "antd";

import React, { useState } from "react";

import ConfirmationBox from "../../../../../../components/common/ConfirmationBox";
import { duration } from "../../../../../../utils/showingSettings";

function Schedule({ workOrderNumber, setIsConfirmationBoxOpen }) {
  const [checked, setChecked] = useState(false);
  return (
    <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
      <h2>Schedule Work Order #{workOrderNumber}</h2>
      <p>This date will be included in status updates to resident.</p>
      <Form layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item label="Scheduled For">
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item>
              <Checkbox checked={checked} onChange={() => setChecked(!checked)}>
                All Day
              </Checkbox>
            </Form.Item>
          </Col>
          {!checked ? (
            <Col span={24}>
              <Row gutter={[8, 0]}>
                <Col span={8}>
                  <Form.Item label="Time">
                    <Input placeholder="HH:MM" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="AM/PM">
                    <Select
                      options={[{ value: "AM" }, { value: "PM" }]}
                      defaultValue="AM"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Duration">
                    <Select options={duration} defaultValue="30 minutes" />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          ) : null}
        </Row>
        <div className="action-buttons">
          <Button type="primary">Save</Button>
          <button
            className="cancel-btn"
            onClick={() => setIsConfirmationBoxOpen(false)}
          >
            Cancel
          </button>
        </div>
      </Form>
    </ConfirmationBox>
  );
}

export default Schedule;
